var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dr-wrapper',_vm._g({attrs:{"model":_vm.model}},_vm.wrapOn),[(_vm.model.Orientation == 'horizontal')?_c('dr-menu-horizontal',{attrs:{"model":_vm.navigation.Menu},on:{"onMenuItemClick":_vm.onMenuItemClick}}):_c('dr-menu-vertical',{attrs:{"model":_vm.navigation.Menu},on:{"onMenuItemClick":_vm.onMenuItemClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }